import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
} from 'firebase/remote-config';
import { isEmpty } from 'lodash';
import Helpers from '../../utilities/helpers';

export default class FirebaseService {
  private static readonly config = {
    apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
    authDomain: `${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`,
    databaseURL: `${process.env.REACT_APP_FIREBASE_DATABASE_URL}`,
    projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
    storageBucket: `${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`,
    messagingSenderId: `${process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID}`,
    appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`,
    measurementId: `${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`,
  };

  private static readonly app = initializeApp(FirebaseService.config);
  private static readonly remoteConfig = getRemoteConfig(FirebaseService.app);
  private static readonly analytics = getAnalytics(FirebaseService.app);

  constructor() {
    FirebaseService.remoteConfig.defaultConfig = {
      test_key: 'Firebase test',
    };
  }

  public async fetchAndActivateRemoteConfig(): Promise<void> {
    await fetchAndActivate(FirebaseService.remoteConfig);
  }

  public static getValue(key: string): string {
    const value = getValue(FirebaseService.remoteConfig, key).asString();
    return isEmpty(value) ? key : value;
  }

  public static logEvent(
    key: string,
    params?: { [key: string]: unknown }
  ): void {
    if (!Helpers.isEnvProd()) {
      console.log(`>> EVENT: ${key}`);
      return;
    }
    logEvent(FirebaseService.analytics, key, params);
  }

  // KEYS
  public static readonly desc = 'desc';
  public static readonly desc_below_1000 = 'desc_below_1000';
  public static readonly now_button = 'now_button';
  public static readonly later_button = 'later_button';
  public static readonly prize_250mb = 'prize_250mb';
  public static readonly degerinde_250mb_text = 'degerinde_250mb_text';
  public static readonly prize_500mb = 'prize_500mb';
  public static readonly degerinde_500mb_text = 'degerinde_500mb_text';
  public static readonly prize_1gb = 'prize_1gb';
  public static readonly degerinde_1gb_text = 'degerinde_1gb_text';
  public static readonly prize_2gb = 'prize_2gb';
  public static readonly degerinde_2gb_text = 'degerinde_2gb_text';
  public static readonly prize_5gb = 'prize_5gb';
  public static readonly degerinde_5gb_text = 'degerinde_5gb_text';
  public static readonly win_100_to_1000_text = 'win_100_to_1000_text';
  public static readonly win_200_to_1000_text = 'win_200_to_1000_text';
  public static readonly win_250_to_1000_text = 'win_250_to_1000_text';
  public static readonly win_300_to_1000_text = 'win_300_to_1000_text';
  public static readonly win_400_to_1000_text = 'win_400_to_1000_text';
  public static readonly win_500_to_1000_text = 'win_500_to_1000_text';
  public static readonly win_600_to_1000_text = 'win_600_to_1000_text';
  public static readonly win_700_to_1000_text = 'win_700_to_1000_text';
  public static readonly win_800_to_1000_text = 'win_800_to_1000_text';
  public static readonly win_900_to_1000_text = 'win_900_to_1000_text';

  public static readonly win_250_to_1000_header_text =
    'win_250_to_1000_header_text';
  public static readonly win_250_text = 'win_250_text';
  public static readonly degerinde_500_point_header =
    'degerinde_500_point_header';

  public static readonly now_information_title = 'now_information_title';
  public static readonly now_information_desc = 'now_information_desc';
  public static readonly now_information_more_than_1gb_title =
    'now_information_more_than_1gb_title';
  public static readonly now_information_more_than_1gb_desc =
    'now_information_more_than_1gb_desc';
  public static readonly app_button = 'app_button';
  public static readonly kazandirio_button = 'kazandirio_button';
  public static readonly later_information_title = 'later_information_title';
  public static readonly later_information_desc = 'later_information_desc';

  public static readonly error_title = 'error_title';
  public static readonly error_desc = 'error_desc';
  public static readonly error_button = 'error_button';
  public static readonly used_link_error_title = 'used_link_error_title';
  public static readonly used_link_error_desc = 'used_link_error_desc';
  public static readonly used_link_error_button = 'used_link_error_button';

  // EVENTS
  public static readonly test_event = 'test_event';
}
